export default class WebEnquiryService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }
  
    createEnquiry(webEnquiryId, assignedTo) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/webenquiries/createenquiry/${webEnquiryId}/${assignedTo}`);
    }

    getCodeweaversData(webEnquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/webenquiries/getcodeweaversdata/${webEnquiryId}`);
    }    

    deleteEnquiry(webEnquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/webenquiries/deleteenquiry/${webEnquiryId}`);
    }    

    listWebEnquiries(criteria) {  
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/webenquiries/listwebenquiries', criteria);
    }

    reprocess(webEnquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/webenquiries/reprocess/${webEnquiryId}`);
    }        
  }

  


// WEBPACK FOOTER //
// ./client/app/components/webEnquiries/webEnquiries.service.js